/* eslint-disable import/no-unresolved, import/extensions */
import { combineReducers } from 'redux';
// import app from './app.store';
import legend from '../components/Viewer/LegendControl/legend.store';
// import { historyReducer, persistHistoryReducer } from './history.store';
// import { routerReducer } from 'react-router-redux';
// import { combineForms } from '@react-schema-form';
// import intl from '../shared/useIntl/stores/intl.reducer';
// import devTools from '../shared/components/DevTools/stores/dev-tools.reducer';
// import app from './app.store';
// import system from '../shared/stores/system.reducer';
// import user from '../shared/stores/user.reducer';
// import report from '../shared/stores/report.reducer';
// import recentlyUsed from '../shared/stores/recently-used.reducer';
// import delivery from '../screens/Delivery/shared/stores/delivery.reducer';
// import widgetTable from '../shared/components/WidgetTablePanel/stores/widget-table-panel.reducer';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// const getReducer = () => {
//   const isClient = typeof window !== 'undefined';
//   // const history: any = isClient ? persistHistoryReducer : historyReducer;
//   return { history };
// };

const rootReducer = combineReducers({
  // routing: routerReducer,
  // app,
  legend: persistReducer({ key: 'legend', storage: storage }, legend),
  // ...getReducer(),
  // devTools,
  // app,
  // system,
  // user,
  // report,
  // recentlyUsed,
  // delivery,
  // widgetTable,
  // schema: combineForms(),
});

export default rootReducer;
